<template>
	<div class="sheet-form">
		<h3 class="sheet-form-title">ESPATOLERO Y LORENZO</h3>
		<div class="row mb-2">
			<div
				v-for="sucu in profile.sucursals"
				class="col-xl-6 sheet-form-tel"
			>
				<strong class="d-block text-nowrap">
					({{ sucu.phones[0].area_code }})
					{{ sucu.phones[0].phone }}
				</strong>
				<small>{{ sucu.address }}</small>
			</div>
		</div>
		<template>
			<div class="form-group">
				<select
					name="sucursal"
					class="sheet-input"
					v-model="form.sucursal"
				>
					<option :value="null">SUCURSAL</option>
					<option v-for="sucu in profile.sucursals" :value="sucu.id">
						{{ sucu.address }}
					</option>
				</select>
			</div>
			<div class="form-group">
				<input
					class="sheet-input"
					placeholder="SU NOMBRE"
					v-model="form.name"
				/>
			</div>
			<div class="form-group">
				<input
					class="sheet-input"
					placeholder="EMAIL"
					v-model="form.email"
				/>
			</div>
			<div class="form-group">
				<input
					class="sheet-input"
					placeholder="TELEFONO"
					v-model="form.phone"
				/>
			</div>
			<div class="form-group">
				<textarea
					class="sheet-input"
					rows="5"
					v-model="form.message"
				></textarea>
			</div>
			<div class="form-group">
				<button class="sheet-submit" @click.prevent="submit">
					CONSULTAR POR EMAIL
				</button>
			</div>
			<div class="form-group m-0">
				<a
					class="sheet-submit-wa"
					target="_blank"
					:href="`https://api.whatsapp.com/send?phone=+${
						whatsapp || '5492235968758'
					}&text=${message}`"
					>CONSULTE POR WHATSAPP</a
				>
			</div>
		</template>
		<small v-if="response" class="d-block mt-3">{{ response }}</small>
		<div v-if="loading" class="spinner-wrap" style="top: 0; left: 0">
			<div class="spinner"></div>
		</div>
	</div>
</template>

<script>
	import Inmokey from '../../Inmokey'
	export default {
		name: 'Form',
		props: [, 'name', 'id', 'whatsapp'],
		data() {
			return {
				loading: true,
				ok: false,
				response: '',
				form: {
					name: null,
					phone: null,
					email: null,
					message: `Estoy interesado en la propiedad *${
						this.name || ''
					} #${this.id || ''}*`,
					property: this.id,
					sucursal: null
				},
				profile: null
			}
		},
		computed: {
			message() {
				return encodeURIComponent(this.form.message)
			}
		},
		methods: {
			submit() {
				this.loading = true
				Inmokey.postMessage(this.form, e => {
					this.loading = false
					if (e.result) {
						this.response = 'Mensaje enviado.'
					} else {
						this.response = e.msg
					}
					this.ok = e.result
				})
			}
		},
		beforeMount() {
			Inmokey.getProfile(profile => {
				this.profile = profile
				this.loading = false
			})
		}
	}
</script>
